import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import { CHATROOMPAGE } from "common/viewContent";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import inputFields from "./inputFields";
import Table from "components/Table";
import Columns from "./Columns";
import CreateChatRoom from "components/Modals/CreateChatRoom";
import {
  getRoomList,
  addRoom,
  getCategoryList,
  addCategory,
  editRoom,
} from "store/actions";
import { getSocket } from "helpers/socket";

const List = () => {
  const { ROOMS, CATEGORY, categoryLoading, loading, totalCount } = useSelector(
    (state) => state.ChatRoom
  );
  const socket = getSocket();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [pageSize, setPageSize] = useState(20);
  const [search_text, setSearch_text] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [allCategory, setAllCategory] = useState([]);
  const [editCategory, setEditCategory] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    value: "",
    label: "All",
    id: "",
  });
  const [editModalShow, setEditModalShow] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    image: "",
    description: "",
  });
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
    category_id: "",
  });
  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          //setDoctor(res);
        }
      };
      dispatch(
        getRoomList({
          data: payload,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const fetchCategory = async () => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          //setDoctor(res);
        }
      };
      dispatch(
        getCategoryList({
          data: {},
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
      category_id: selectedOption.id,
    });
  };
  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
      category_id: "",
    }));
    setSearch_text("");
    setSelectedOption(allCategory[0]);
  };

  const onCliclNavigate = (summary) => {
    navigate(`/admin/chat-rooms/detail`, {
      state: { summary: summary },
    });
    localStorage.setItem("summary", JSON.stringify(summary));
  };

  useEffect(() => {
    fetchData(filter);
    fetchCategory();
    setcolumns(
      Columns({
        onCliclNavigate,
        currentPage: filter?.pageNo,
        pageSize,
        handleEdithandler,
        handleUserStatus,
      })
    );
  }, [filter]);

  useEffect(() => {
    const Category = CATEGORY?.map((obj) => {
      return { value: obj.name, label: obj.name, id: obj.id };
    });
    setAllCategory([{ value: "", label: "All", id: "" }, ...Category]);
    inputFields.find((field) => field.type === "dynamic_select").options =
      Category || [];
  }, [CATEGORY]);

  const handleTableChange = (pageNumber, newPageSize) => {
    setCurrentPage(pageNumber);
  };
  const handleEdithandler = (info) => {
    const updatedInfo = {
      ...info,
      bannerImage: info.image,
    };
    setFormData({ ...formData, ...updatedInfo });
    setEditModalShow(true);
    setIsEdit(true);
  };

  const handleCreate = (info) => {
    const detail = allCategory.find((val) => val.value === info.category_name);
    let data = {
      name: info.name,
      image: info.bannerImage,
      description: info.description,
      category_name: info.category_name,
      category_id: detail.id,
    };
    if (info.id) {
      data.id = info.id;
    }
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
          setFormData({
            name: "",
            image: "",
            description: "",
          });
        } else {
          toast.success(res.message);
          fetchData(filter);
          setEditModalShow(false);
          setIsEdit(false);
          setFormData({
            name: "",
            image: "",
            description: "",
          });
        }
      };
      if (data.hasOwnProperty("id")) {
        dispatch(
          editRoom({
            data: data,
            callback,
          })
        );
      } else {
        dispatch(
          addRoom({
            data: data,
            callback,
          })
        );
      }
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleUserStatus = (row, status) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData(filter);
          toast.success("Status Changed");
        }
      };
      dispatch(
        editRoom({
          data: { id: row?.id, status: status },
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const onSelect = (val) => {
    console.log(val);
    setSelectedOption(val);
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      category_id: val.id,
    });
  };
  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {editModalShow && (
        <CreateChatRoom
          show={editModalShow}
          handleClose={() => {
            setEditModalShow(false);
            setIsEdit(false);
            setFormData({
              name: "",
              image: "",
              description: "",
            });
          }}
          title={isEdit ? "Edit Room" : "Create Room"}
          content={""}
          handleConfirm={handleCreate}
          loading={loading}
          initialValues={formData}
        />
      )}
      <Helmet title={CHATROOMPAGE.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{CHATROOMPAGE.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">
              {CHATROOMPAGE.CURRENT_MODULE}{" "}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-12">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h2 className="section-title">{CHATROOMPAGE.TOP_CONTENT}</h2>
                  <button
                    onClick={() => setEditModalShow(true)}
                    className="d-flex align-items-center justify-content-center btn commonBtn"
                  >
                    Create Room
                  </button>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header px-3">
                    <div className="row w-100">
                      <div className="col-lg-4 col-sm-12 col-md-12 my-2">
                        <input
                          className="form-control"
                          name="search_text"
                          onChange={(e) => setSearch_text(e.target.value)}
                          value={search_text}
                          placeholder="Search using name, email..."
                        />
                      </div>
                      <div className="col-lg-4 col-sm-12 col-md-12 my-2">
                        <Select
                          options={allCategory}
                          value={selectedOption}
                          onChange={onSelect}
                          //placeholder="Select a flavor"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!loading && ROOMS?.length > 0 && (
          <Table
            data={ROOMS}
            columns={columns}
            setFilter={setFilter}
            handleTableChange={handleTableChange}
            totalCount={totalCount}
            filter={filter}
          />
           )}
          {ROOMS?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Chat Room Found</p>
          )}
        </div>
      </section>
    </>
  );
};
export default List;
